// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/vapour-lock.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/vapour-lock/vapour-lock.js';

mount([g0]);
